(() => {
"use strict";
const drawer=document.querySelector("[data-rayni-cart-drawer]");
const overlay=document.querySelector("[data-rayni-cart-overlay]");
const surfaces=Array.from(document.querySelectorAll("[data-rayni-cart-surface]"));
if(!surfaces.length)return;
const root=window.Shopify?.routes?.root||"/";
const rayniId="11168974012759";
let busy=false;
let lastFocus=null;
let cachedCart=null;
const money=(value,currency)=>new Intl.NumberFormat("de-DE",{style:"currency",currency:currency||"EUR"}).format((Number(value)||0)/100);
function errorMessage(msg){surfaces.forEach(s=>{const slot=s.querySelector("[data-rayni-cart-error]");if(!slot)return;slot.textContent=msg||"";slot.hidden=!msg;});}
function counts(cart){document.querySelectorAll("[data-cart-count]").forEach(el=>el.textContent=String(cart.item_count||0));}
function getQtyOfRayni(cart){return(cart.items||[]).filter(item=>String(item.product_id)===rayniId).reduce((sum,item)=>sum+(Number(item.quantity)||0),0);}
function tierCode(q){return q>=4?"RAYNI4-20":q===3?"RAYNI3-15":q===2?"RAYNI2-10":"";}
async function request(path,data){
 const options={headers:{Accept:"application/json"}};
 if(data!==undefined){options.method="POST";options.headers["Content-Type"]="application/json";options.body=JSON.stringify(data);}
 const response=await fetch(root+path,options);
 let body;try{body=await response.json()}catch{body={}};
 if(!response.ok)throw new Error(body.description||body.message||"Der Warenkorb konnte nicht aktualisiert werden.");
 return body;
}
function node(tag,className,content){
 const n=document.createElement(tag);if(className)n.className=className;if(content!==undefined)n.textContent=String(content);return n;
}
function cartLine(item,surface,cart){
 const line=node("article","rayni-cart-line");line.dataset.rayniCartLine=String(item.key||"");
 const photo=node("div","rayni-cart-image"),pic=document.createElement("img");
 const source=item.image||(item.featured_image&&item.featured_image.url)||surface.dataset.fallbackImage;
 pic.src=source||"";pic.alt=item.product_title||"Regenschirm";pic.width=180;pic.height=180;pic.loading="lazy";
 if(source)photo.appendChild(pic);
 const info=node("div","rayni-cart-line-info");
 const product=node("a","rayni-cart-product-title",item.product_title||item.title||"Produkt");
 const url=String(item.url||"");product.href=url.startsWith("/")&&!url.startsWith("//")?url:"/products/rayni-umbrella";
 info.appendChild(product);
 const variant=String(item.variant_title||"");
 if(variant && !/^(Default Title|Standardtitel|Default)$/i.test(variant))info.appendChild(node("p","rayni-cart-variant",variant));
 const properties=item.properties||{};
 Object.keys(properties).forEach(key=>{if(!key.startsWith("_")&&properties[key]!==null&&properties[key]!=="")info.appendChild(node("p","rayni-cart-variant",key+": "+String(properties[key])));});
 const qty=node("div","rayni-cart-quantity");qty.setAttribute("aria-label","Menge ändern");
 const minus=node("button","","−");minus.type="button";minus.dataset.rayniCartAction="minus";minus.setAttribute("aria-label","Menge verringern");
 const input=document.createElement("input");input.type="number";input.value=String(item.quantity||1);input.min="0";input.step="1";input.inputMode="numeric";input.dataset.rayniCartQuantity="";input.setAttribute("aria-label","Anzahl "+(item.product_title||"Produkt"));
 const plus=node("button","","+");plus.type="button";plus.dataset.rayniCartAction="plus";plus.setAttribute("aria-label","Menge erhöhen");
 qty.append(minus,input,plus);info.append(qty);
 const remove=node("button","rayni-cart-remove","Entfernen");remove.type="button";remove.dataset.rayniCartAction="remove";info.appendChild(remove);
 const price=node("strong","rayni-cart-line-price");const original=Number(item.original_line_price)||0,final=Number(item.final_line_price??item.line_price??original)||0;
 if(original>final){price.appendChild(node("del","",money(original,cart.currency)));}
 price.appendChild(node("span","",money(final,cart.currency)));
 line.append(photo,info,price);return line;
}
function render(cart){
 cachedCart=cart;counts(cart);
 surfaces.forEach(surface=>{
  const box=surface.querySelector("[data-rayni-cart-lines]"),footer=surface.querySelector("[data-rayni-cart-bottom]"),count=surface.querySelector("[data-rayni-cart-item-count]");
  if(!box)return;box.replaceChildren();if(count)count.textContent=String(cart.item_count||0);
  if(!cart.item_count){
   const empty=node("div","rayni-cart-empty");
   empty.append(node("div","rayni-cart-empty-symbol","☂"),node("h3","","Dein Warenkorb ist noch leer."),node("p","","Entdecke den Rayni Umbrella – bereit für deinen nächsten Regentag."));
   const link=node("a","","Rayni Umbrella ansehen");link.href="/products/rayni-umbrella";empty.appendChild(link);box.appendChild(empty);
   if(footer)footer.hidden=true;return;
  }
  (cart.items||[]).forEach(item=>box.appendChild(cartLine(item,surface,cart)));
  if(footer)footer.hidden=false;
  const subtotal=surface.querySelector("[data-rayni-cart-subtotal]");
  if(subtotal)subtotal.textContent=money(cart.total_price,cart.currency);
  const saved=surface.querySelector("[data-rayni-cart-savings]");
  const reduction=Math.max(0,Number(cart.total_discount)||0);
  const qty=getQtyOfRayni(cart),discount=tierCode(qty);
  if(saved){
    if(reduction>0){saved.hidden=false;saved.textContent="Dein Vorteil: "+money(reduction,cart.currency)+" gespart";}
    else if(discount){saved.hidden=false;saved.textContent="Mengenrabatt "+discount+" – Gültigkeit im Checkout prüfen.";}
    else saved.hidden=true;
  }
 });
}
async function refresh(){
 try{const cart=await request("cart.js");render(cart);errorMessage("");return cart}
 catch(error){errorMessage(error.message);return null}
}
async function reconcile(cart){
 const qty=getQtyOfRayni(cart),want=tierCode(qty);
 const found=(cart.cart_level_discount_applications||[]).some(d=>String(d.title||"").toLowerCase().includes("rayni umbrella"));
 const codes=Array.isArray(cart.discount_codes)?cart.discount_codes.map(d=>String(d.code||"").toUpperCase()):[];
 const existingRayni=codes.some(c=>/^RAYNI[234]-(10|15|20)$/.test(c));
 if(want){return await request("cart/update.js",{discount:want});}
 if(found||existingRayni){return await request("cart/update.js",{discount:""});}
 return cart;
}
async function modifyLine(key,quantity){
 if(busy)return;
 busy=true;errorMessage("");surfaces.forEach(s=>s.setAttribute("aria-busy","true"));
 try{let cart=await request("cart/change.js",{id:key,quantity});cart=await reconcile(cart);render(cart)}
 catch(error){errorMessage(error.message);await refresh()}
 finally{busy=false;surfaces.forEach(s=>s.removeAttribute("aria-busy"));}
}
async function applyCode(code){
 if(busy)return;busy=true;errorMessage("");
 try{const cart=await request("cart/update.js",{discount:code});render(cart);if(code&&!cart.total_discount)errorMessage("Code übergeben. Bitte überprüfe den Rabatt an der Kasse.");}
 catch(error){errorMessage(error.message)}
 finally{busy=false}
}
function close(){
 if(!drawer||drawer.hidden)return;
 drawer.hidden=true;overlay.hidden=true;drawer.setAttribute("aria-hidden","true");document.body.classList.remove("rayni-cart-open");
 if(lastFocus?.isConnected)lastFocus.focus();
}
function open(){
 if(!drawer)return;
 lastFocus=document.activeElement;
 drawer.hidden=false;if(overlay)overlay.hidden=false;
 drawer.setAttribute("aria-hidden","false");
 document.body.classList.add("rayni-cart-open");
 drawer.querySelector("[data-rayni-cart-close]")?.focus();
 refresh();
}
document.querySelectorAll("[data-rayni-cart-trigger]").forEach(a=>a.addEventListener("click",e=>{e.preventDefault();open()}));
document.addEventListener("rayni:cart-added",()=>open());
drawer?.querySelector("[data-rayni-cart-close]")?.addEventListener("click",close);
overlay?.addEventListener("click",close);
document.addEventListener("keydown",event=>{
 if(!drawer||drawer.hidden)return;
 if(event.key==="Escape"){event.preventDefault();close();return}
 if(event.key!=="Tab")return;
 const focusables=Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),input:not([disabled])')).filter(el=>!el.closest("[hidden]"));
 if(!focusables.length)return;
 const first=focusables[0],last=focusables[focusables.length-1];
 if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus()}
 else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus()}
});
surfaces.forEach(surface=>{
 surface.addEventListener("click",event=>{
  const b=event.target.closest("[data-rayni-cart-action]");if(!b||busy)return;
  const line=b.closest("[data-rayni-cart-line]");if(!line)return;
  const input=line.querySelector("[data-rayni-cart-quantity]"),n=Number(input?.value)||0;
  const action=b.dataset.rayniCartAction;
  modifyLine(line.dataset.rayniCartLine,action==="remove"?0:action==="plus"?n+1:Math.max(0,n-1));
 });
 surface.addEventListener("change",event=>{
  if(!event.target.matches("[data-rayni-cart-quantity]")||busy)return;
  const input=event.target,line=input.closest("[data-rayni-cart-line]");
  if(!line)return;
  const q=Math.max(0,Math.floor(Number(input.value)||0));
  modifyLine(line.dataset.rayniCartLine,q);
 });
 surface.querySelector("[data-rayni-cart-discount-form]")?.addEventListener("submit",event=>{
  event.preventDefault();const input=event.currentTarget.querySelector("[data-rayni-cart-code]");
  const code=String(input?.value||"").trim();
  if(!code){errorMessage("Bitte gib einen Rabattcode ein.");return}
  applyCode(code);
 });
 surface.querySelector("[data-rayni-cart-continue]")?.addEventListener("click",event=>{
  if(surface===drawer){event.preventDefault();close()}
 });
});
if(surfaces.some(s=>s.hasAttribute("data-rayni-cart-page")))refresh();
document.addEventListener("cart:updated",event=>{if(event.detail&&event.detail.items)render(event.detail);else refresh()});
})();